module.exports = require("@material-ui/icons/KeyboardArrowLeft");